//Home
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Search from "../assets/images/search-image.png";
import BellIcon from "../assets/icons/bell.svg"; // Assuming you have the bell icon SVG locally
import MapComponent from "./MapComponent";
import { useLocation } from "react-router-dom";
import PolygonMapComponent from "./PolygonMapComponent";
import { getUserIdFromToken } from "../auth/authUtils"
import PolygonBlockMap from "./PolygonBlockMap";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import MapIcon from '../assets/icons/Maps.svg'
import GridIcon from '../assets/icons/Grid.svg'
import LocationIcon from '../assets/icons/location.svg';
import FavouriteFalse from "../assets/icons/favouritefalse.svg";
import FavouriteTrue from "../assets/icons/favouritetrue.svg";
import OfficeIcon from '../assets/icons/OfficeList.svg'
import BussinessIcon from '../assets/icons/Bussiness.svg'
import OtherIcon from '../assets/icons/OtherList.svg'
import HomeIcon from '../assets/icons/HomeLIst.svg'

import ReactLoading from 'react-loading';
interface Address {
  id: string;
  email: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressType: string;
  pinCode: string;
  blockCode: string;
  addressCode: string;
  pamCode?: string;
  latitude: number;
  longitude: number;
  userId: string;
  roleId: string;
  createdDate: string;
  updatedDate: string;
  deleteReason?: string;
  deleteStatus?: boolean;
  isFavourite: boolean
}
interface UserProfile {
  id: number;
  userName: string;
  email: string;
  phoneNumber: string;
  azureToken: string;
  roleId: number;
  roleName: string;
  createdDate: string;
  updatedDate: string;
  status: string | null;
}

interface PamCodeSuggestion {
  pamCode: string;
}


interface BoundaryData {
  latitude: number;
  longitude: number;
}

const Home: React.FC<{ updateUserName: (newUserName: string) => void }> = ({ updateUserName }) => {
  const navigate = useNavigate();

  const [searchData, setSearchData] = useState<string>('');
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [addresses, setAddresses] = useState<any[]>([]); // Store addresses fetched from API
  const [showResults, setShowResults] = useState(false);
  const [viewAsGrid, setViewAsGrid] = useState(true);
  const [addressResults, setAddressResults] = useState<Address[]>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false); // For user profile dropdown
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null); // Store user profile data
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false); // Modal visibility state
  const [isPolygonView, setIsPolygonView] = useState(false); // Flag to control polygon view
  const [isPolygonBlockView, setIsPolygonBlockView] = useState(false);
  const [boundaryData, setBoundaryData] = useState<BoundaryData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [userName, setUserName] = useState('');
  const validAddresses = addressResults.filter(address => address.addressLine1 !== null);

  const [loading, setLoading] = useState(false);
  // const [defaultAddress, setDefaultAddress] = useState<Address[]>([
  //   {
  //     id: "default-id",
  //     email: "default@example.com",
  //     phoneNumber: "1234567890",
  //     addressLine1: "",
  //     addressLine2: "Kochi",
  //     addressLine3: "Kerala",
  //     pinCode: "",
  //     blockCode: "default-block",
  //     addressCode: "default-address",
  //     latitude: 9.9312,
  //     longitude: 76.2673,
  //     userId: "default-user",
  //     roleId: "default-role",
  //     createdDate: new Date().toISOString(),
  //     updatedDate: new Date().toISOString(),
  //     isFavourite: false
  //   },
  // ]);

  useEffect(() => {
    const storedUserName = localStorage.getItem('userName');
    // console.log('Retrieved UserName from localStorage:', storedUserName); // Check what is retrieved
    if (storedUserName) {
      setUserName(storedUserName);
    }
    const handleStorageChange = () => {
      const updatedUserName = localStorage.getItem('userName');
      if (updatedUserName) {
        setUserName(updatedUserName);

      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);

    };
  }, []);


  const pamCodeRegex = /^\d{6}-\d{2}-\d{4}$/;

  const handleAddressClickDetails = (id: string) => {
    // const addressId = pamCode.substring(10); // Get last remaining digits of pamCode
    navigate(`/address-details/${id}`);
  };
  // const goToAddressDetails = (id: string) => {
  //   console.log("Navigating to address details, id:", id);
  //   navigate(`/address-details/${id}`);
  // };
  const handleNavigateToGoogleMaps = (latitude: number, longitude: number) => {
    // Construct the Google Maps URL using the query parameter for latitude and longitude
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    window.open(googleMapsUrl, '_blank'); // Open in a new tab
  };

  const fetchGlobalAddresses = async (sanitizedQuery: string) => {
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Session expired. Please log in again.');
      navigate('/');
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `https://pamsapi.vofoxsolutions.com/api/address/SearchAddressAsync?searchData=${sanitizedQuery}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
  
      if (!response.ok) {
        if (response.status === 401) {
          toast.error('Session expired or unauthorized. Please log in again.');
          navigate('/');
        } else if (response.status !== 404) {
          toast.error('Failed to fetch addresses. Please try again.');
        }
        return;
      }
  
      const data = await response.json();
  
      let addressesWithPamCode: any[] = [];
  
      if (sanitizedQuery.length === 10) {
        let tempAddresses: any[] = [];
        if (Array.isArray(data)) {
          tempAddresses = data;
        } else if (data.addresses && Array.isArray(data.addresses)) {
          tempAddresses = data.addresses;
        }
  
        const validAddresses = tempAddresses.filter(
          (address: any) => address.addressLine1 && address.addressLine1.trim() !== ""
        );
  
        const validBoundary = data.boundaryData !== null && data.boundaryData !== undefined;
  
        if (validBoundary) {
          if (validAddresses.length > 0) {
            addressesWithPamCode = validAddresses.map((address: any) => ({
              ...address,
              pamCode: `${address.pinCode}-${address.blockCode}-${address.addressCode}`,
              displayText: `${address.addressLine1}: ${address.pinCode}-${address.blockCode}-${address.addressCode}`
            }));
          } else {
            addressesWithPamCode = [];
          }
        } else {
          if (!toast.isActive("no-results")) {
            toast.error("No results found for your search.", { toastId: "no-results",  autoClose:1000});

          }
          addressesWithPamCode = [];
        }
      } else {
        if (Array.isArray(data)) {
          addressesWithPamCode = data.map((address: any) => ({
            ...address,
            pamCode: `${address.pinCode}-${address.blockCode}-${address.addressCode}`,
            displayText: `${address.addressLine1}: ${address.pinCode}-${address.blockCode}-${address.addressCode}`
          }));
        } else {
          addressesWithPamCode = [];
        }
      }
  
      if (addressesWithPamCode.length === 0 && !data.boundaryData) {
        if (!toast.isActive("no-results")) {
          toast.error("No results found for your search.", { toastId: "no-results" });
        }
        setSuggestions([]);
        setAddresses([]);
      } else {
        setSuggestions(addressesWithPamCode);
        setAddresses(addressesWithPamCode);
      }
    } catch (error) {
      console.error('Error fetching global addresses:', error);
    } finally {
      setLoading(false);
    }
  };
  




  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
    setSearchData(value); // Ensure only numbers are stored

    if (value.length > 9) {
      const sanitizedQuery = value.replace(/-/g, '').trim();
      fetchGlobalAddresses(sanitizedQuery);
    } else {
      setSuggestions([]);
    }
  };
  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSearchClick();
  };

  const HeartClick = async (addressId: any, isFavourite: boolean) => {
    setAddressResults((prevData) =>
      prevData.map((item) =>
        item.id === addressId ? { ...item, isFavourite: !item.isFavourite } : item
      )
    );


    const token = localStorage.getItem('token');

    if (!token) {
      console.error('Token not found. User might be logged out.');
      return;
    }

    try {
      if (!isFavourite) {
        // POST request to add to favourites
        //const apiUrl = 'http://192.168.7.108:7448/api/AddressFavourites';
        const apiUrl = 'https://pamsapi.vofoxsolutions.com/api/AddressFavourites/AddToFavouritesAsync';

        const payload = {
          addressId,
          isFavourite: true,
        };

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          console.error('Failed to add to favourites:', response.status, response.statusText);
          revertFavouriteState(addressId, isFavourite);
          return;
        }

        //console.log("ggggg", response);
      }
      else {
        // DELETE request to remove from favourites
        //const apiUrl = `http://192.168.7.108:7448/api/AddressFavourites?addressId=${addressId}`;
        const apiUrl = `https://pamsapi.vofoxsolutions.com/api/AddressFavourites/RemoveFromFavouritesAsync?addressId=${addressId}`;

        const response = await fetch(apiUrl, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          console.error('Failed to remove from favourites:', response.status, response.statusText);
          revertFavouriteState(addressId, isFavourite);
          return;
        }

        //console.log('Successfully removed from favourites.');
      }
    } catch (error) {
      console.error('An error occurred while updating favourite status:', error);
      revertFavouriteState(addressId, isFavourite);
    }
  };

  // Helper function to revert the favourite state in case of an error
  const revertFavouriteState = (addressId: number, originalState: boolean) => {
    setAddresses((prevData) =>
      prevData.map((item) =>
        item.id === addressId ? { ...item, isFavourite: originalState } : item
      )
    );
  };


  const handleSearchClick = () => {
    // setLoading(true);
    const editedSearchData = searchData.replace(/-/g, '');
    fetchAddressResults(editedSearchData);
    setSuggestions([]); // Clear suggestions when the search button is clicked

  };

  const handleAddressClick = (pamCode: string) => {
    const selectedAddress = addresses.find((address: any) => address.pamCode === pamCode);
    if (selectedAddress) {
      setSearchData(pamCode || '');
      setSuggestions([]);
      setAddressResults([selectedAddress]);
      setShowResults(true);
      setViewAsGrid(false); // Show grid view by default 
      setIsPolygonView(false);
      setIsPolygonBlockView(false);
      if (selectedAddress.latitude && selectedAddress.longitude) {
        setBoundaryData([{ latitude: selectedAddress.latitude, longitude: selectedAddress.longitude, }]);
      }
    }

  };
  const handleLocationIconClick = (latitude: number, longitude: number) => {
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    window.open(googleMapsUrl, '_blank');
  };
  const handleLogout = () => {
    // Clear user session (localStorage, sessionStorage, or cookies)
    localStorage.removeItem('userToken'); // Example: remove the user token or session info
    sessionStorage.clear(); // Clear sessionStorage if needed
    // You can also clear cookies if used for session management

    // Redirect to the Register page
    navigate('/'); // Redirects to localhost:3000/register
  };

  const fetchAddressResults = async (searchData: string) => {
    setIsLoading(true);
  
    // Validate that the search term is not empty.
    if (!searchData.trim()) {
      if (!toast.isActive("no-search")) {
        toast.info("Please enter a search term.", { toastId: "no-search" });
      }
      setIsLoading(false);
      return;
    }
  
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No authorization token found.");
      }
  
      const response = await fetch(
        `https://pamsapi.vofoxsolutions.com/api/address/SearchAddressAsync?searchData=${searchData}`,
        {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      if (!response.ok) {
        throw new Error("Failed to fetch address data");
      }
  
      const data = await response.json();
  
      // Handle a 10-digit (pincode+blockcode) search.
      if (/^\d{10}$/.test(searchData)) {
        // Set the view for polygon block map mode.
        setIsPolygonView(false);
        setIsPolygonBlockView(true);
        setViewAsGrid(false);
  
        // Expect the API to return an object with "addresses" and "boundaryData"
        const { addresses, boundaryData } = data;
  
        // Check if addresses array contains any valid addressLine1 entries
        const hasValidAddresses = addresses && addresses.some((address: any) => address.addressLine1);
  
        const validBoundary = boundaryData !== null && boundaryData !== undefined;
  
        if (validBoundary) {
          // The block exists in the DB.
          setAddressResults(addresses || []);
          setBoundaryData(boundaryData);
          setShowResults(true);
          setSuggestions([]);
        } else {
          // The block is not in the DB.
          toast.error("No results found for your search.", { toastId: "no-results" });
          setAddressResults([]);
          setBoundaryData([]);
          setShowResults(false);
        }
      }
      // Handle a 6-digit (pincode-only) search.
      else if (/^\d{6}$/.test(searchData)) {
        setIsPolygonView(true);
        setIsPolygonBlockView(false);
        setViewAsGrid(false);
  
        if (data && Array.isArray(data) && data.length > 0) {
          setAddressResults(data);
          setBoundaryData(
            data.map((address: any) => ({
              latitude: address.latitude,
              longitude: address.longitude,
            }))
          );
          setShowResults(true);
        } else {
          toast.error("No results found for your search.", { toastId: "no-results" });
          setAddressResults([]);
          setBoundaryData([]);
          setShowResults(false);
        }
      }
      // Handle any other search type.
      else {
        setIsPolygonView(false);
        setIsPolygonBlockView(false);
        setViewAsGrid(false);
  
        if (data && Array.isArray(data) && data.length > 0) {
          setAddressResults(data);
          setShowResults(true);
        } else {
          toast.error("No results found for your search.", { toastId: "no-results" });
          setAddressResults([]);
          setShowResults(false);
        }
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
      setErrorMessage("An error occurred while fetching addresses.");
      setAddressResults([]);
      setBoundaryData([]);
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };
  
  






  const toggleView = (view: "grid" | "map") => {
    if (view === "grid") {
      setViewAsGrid(true);
    } else {
      setViewAsGrid(false);
    }
  };
  const formatPamCode = (code: string) => {
    // Assuming pamCode is in the format '6820170000117' and needs to be formatted as '682017-0000-117'
    const pincode = code.slice(0, 6); // First 6 digits as pincode
    const blockCode = code.slice(6, 10); // Next 4 digits as blockcode
    const addressCode = code.slice(10); // Remaining digits as addresscode

    return `${pincode}-${blockCode}-${addressCode}`;
  };

  // Toggle user profile dropdown
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };



  const fetchUserProfile = async () => {
    const token = localStorage.getItem("token"); // Get the stored token
    if (!token) {
      console.error('Token not found in localStorage');
      setErrorMessage('Session expired. Please log in again.');
      navigate('/home'); // Redirect to login page
      return; // Stop execution if token is not found
    }

    try {
      // console.log('Fetching user profile...');
      // console.log('Token:', token); // Log the token for debugging

      const response = await fetch('https://pamsapi.vofoxsolutions.com/api/User/GetUserProfile', {
        //const response = await fetch('http://192.168.7.108:7448/api/User', {

        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`, // Add token to Authorization header
          "Content-Type": "application/json", // Ensure Content-Type is set
        },
      });

      // console.log('Response Status:', response.status); // Log the response status

      if (!response.ok) {
        throw new Error(`Failed to fetch user profile: ${response.status} ${response.statusText}`);
      }

      const data: UserProfile = await response.json();
      // console.log('Fetched User Profile:', data); // Log the fetched user profile
      setUserProfile(data); // Save user profile to state
      setUserName(data.userName); // Update the username state
      updateUserName(data.userName); // Update the username in the parent component

      setIsProfileModalOpen(false); // Open the profile modal

      // Pass user profile data via navigate to profile page
      navigate('/profile', {
        state: {
          userName: data.userName,
          email: data.email,
          phoneNumber: data.phoneNumber,
        },
      });
    } catch (error) {
      console.error('Error fetching user profile:', error);
      // toast.error("An error occurred while fetching user profile.");
    }
  };


  const closeProfileModal = () => {
    setIsProfileModalOpen(false);
  };
  const handleUpdateClick = () => {
    if (userProfile) {
      navigate("/", { state: { userProfile } });
    }
  };

  // Add this skeleton loader component
  const HomePageSkeleton = () => (
    <div className="animate-pulse">
      {/* Search Bar Skeleton */}
      <div className="w-full bg-indigo-100 p-6 rounded-md shadow-sm">
        <div className="relative w-full">
          <div className="h-12 w-full bg-gray-200 rounded-lg"></div>
          <div className="absolute right-3 top-3">
            <div className="h-6 w-6 bg-gray-300 rounded-full"></div>
          </div>
        </div>
      </div>

      {/* View Toggle Buttons Skeleton */}
      <div className="container py-4 mx-auto bg-transparent m-1 rounded-lg">
        <div className="flex justify-between items-center">
          <div className="flex gap-2">
            <div className="h-10 w-24 bg-gray-200 rounded-md"></div>
            <div className="h-10 w-24 bg-gray-200 rounded-md"></div>
          </div>
        </div>
      </div>

      {/* Grid View Results Skeleton */}
      <div className="grid grid-cols-2 gap-4 rounded-lg bg-white shadow-shadow1 w-auto p-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="border p-3 rounded-md shadow-sm h-24">
            <div className="flex justify-between items-start">
              <div className="space-y-2 flex-1">
                <div className="h-4 w-3/4 bg-gray-200 rounded"></div>
                <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
                <div className="h-4 w-2/3 bg-gray-200 rounded"></div>
              </div>
              <div className="flex gap-2">
                <div className="h-8 w-8 bg-gray-200 rounded"></div>
                <div className="h-8 w-8 bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="bg-slate-100 flex flex-col pl-4 justify-between min-h-screen relative pt-16 select-none">
      <ToastContainer position="top-right" autoClose={1000} hideProgressBar />
      {/* Header with Bell Icon and User Profile */}
      <header className='flex items-center fixed top-0 right-4 left-5 z-10 justify-between px-6 py-1 bg-white'>

        <h1 className='text-lg font-semibold'></h1>
        <div className="flex justify-end items-center gap-6">        {/* Bell Icon */}
          {/* <div className="relative"> */}
          {/* <img src={BellIcon} alt="Notifications" className="w-6 h-6 cursor-pointer" /> */}
          {/* Optionally add a notification count indicator */}

          {/* </div> */}

          {/* User Profile Dropdown */}
          <div className="relative m-3">
            <button
              onClick={toggleDropdown}
              className="relative border border-whitesmoke focus:outline-none flex rounded-full h-12 items-center px-2 gap-2"
            >
              <div className="w-8 h-8 overflow-hidden rounded-full">
                <img
                  className="object-cover w-full h-full"
                  src="https://cdn-icons-png.flaticon.com/128/18573/18573514.png"
                  alt="User Avatar"
                />
              </div>
              <h1>{userName || 'Guest'}</h1>          </button>

            {dropdownOpen && (
              <>
                {/* Close dropdown when clicking outside */}
                <div
                  onClick={() => setDropdownOpen(false)}
                  className="fixed inset-0 z-10 w-full h-full"
                ></div>

                {/* Dropdown menu */}
                <div className="absolute right-0 z-20 w-48 mt-2 bg-white rounded-md shadow-xl">
                  <button
                    onClick={fetchUserProfile}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                  >
                    Profile
                  </button>
                  {/* <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white">
                  Products
                </a> */}
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                  >
                    Log out
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </header>

      {/* Profile Modal */}
      {/* {isProfileModalOpen && userProfile && (
        <div
          onClick={closeProfileModal}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
        >
          <div
            className="bg-white p-6 rounded-md w-96 relative z-60" // Added z-60 here
            onClick={(e) => e.stopPropagation()} // Prevent propagation to parent click handler
          >
            <h2 className="text-xl border-b font-semibold pb-2 mb-5">User Profile</h2>
            <p className="mb-2">
              <strong>Username:</strong> {userProfile.userName}
            </p>
            <p className="mb-2">
              <strong>Email:</strong> {userProfile.email}
            </p>
            <p className="mb-2">
              <strong>Phone Number:</strong> {userProfile.phoneNumber}
            </p>
            <button
              onClick={closeProfileModal}
              className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-md"
            >
              Close
            </button>
            {/* Update Button */}
      {/* <button
              onClick={handleUpdateClick}
              className="mt-4 ml-2 bg-green-600 text-white px-4 py-2 rounded-md"
            >
              Update
            </button>

          </div>
        </div>
      )} */}


      {/* Search Section */}
      <div className="w-full bg-indigo-100 p-6 rounded-md shadow-sm relative mt-6 select-none">
  <div className="flex flex-col lg:flex-row lg:space-x-4 justify-end items-end">
    <h3 className="text-lg sm:text-xl text-gray-800 font-semibold mb-2 mt-1 lg:mt-0">
      Search Here!
    </h3>
    <div className="relative rounded-md flex w-full lg:w-auto">
      <form onSubmit={handleFormSubmit}>
        <input
          type="text"
          maxLength={16}
          placeholder="Search pamcode here..."
          className="flex-grow pl-4 pr-2 py-2 rounded-md focus:outline-none border-none placeholder-gray-500 w-full sm:w-auto"
          value={searchData}
          onChange={handleInputChange}
        />
      </form>
      <button
        className="flex items-center px-4 py-2 bg-blue-600 text-white text-sm rounded-r-md"
        onClick={handleSearchClick}
      >
        {loading ? (
          <ReactLoading type="spin" color="#fff" height={24} width={24} />
        ) : (
          <svg
            className="w-5 h-5 mr-2"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </button>

      {suggestions.length > 0 && (
        <ul
          className="absolute top-10 bg-white border rounded-lg shadow-lg w-full mt-2 max-h-60 overflow-y-auto"
          style={{ zIndex: 2000, borderColor: '#ddd' }}
        >
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              className="p-2 flex items-center justify-between cursor-pointer text-black text-lg border-b border-gray-200 hover:bg-blue-100 focus:bg-blue-200 focus:outline-none"
              onClick={() => {
                if (suggestion.pamCode) {
                  handleAddressClick(suggestion.pamCode);
                  setSearchData(suggestion.pamCode);
                } else {
                  console.error('pamCode not found in suggestion:', suggestion);
                }
                setSuggestions([]);
              }}
            >
              {suggestion.displayText || JSON.stringify(suggestion)}
              <img
                src={LocationIcon}
                alt="Map Icon"
                className="w-6 h-6 ml-2 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent the li onClick from firing
                  handleLocationIconClick(suggestion.latitude, suggestion.longitude);
                }}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>

  {errorMessage && <p className="text-red-500 mt-2">{errorMessage}</p>}

  {/* Illustration image placed on the left corner for large screens */}
  <div className="hidden lg:block absolute left-0 bottom-0">
    <img src={Search} alt="Illustration" className="h-20" />
  </div>
</div>


      <main className="flex-1 overflow-x-hidden overflow-y-auto ">
        <div>
          {/* View Toggle Buttons */}
          {showResults && (
            <div className="mt- flex gap-4">
              <div className="flex mt-3 rounded-lg shadow-shadow1 bg-white border border-white w-auto">
                <ul
                  className="relative flex flex-wrap px-2.5 py-3.5 list-none rounded-md bg-white"
                  data-tabs="tabs"
                  role="list"
                >
                  {/* Map Button: Always rendered */}
                  <li className="z-30 flex-auto text-center mr-2">
                    <a
                      className={`z-30 flex items-center justify-center w-full px-4 py-2 text-sm mb-0 transition-all ease-in-out border border-white rounded-md cursor-pointer ${!viewAsGrid ? 'border-white text-blue-500 bg-[#D6DFFE]' : 'text-slate-600 bg-inherit'
                        }`}
                      role="tab"
                      aria-selected={!viewAsGrid}
                      onClick={() => toggleView("map")}
                    >
                      <img src={MapIcon} alt="View on Map" className="w-4 h-4 mr-1.5" />
                      <span className="ml-1">Map</span>
                    </a>
                  </li>

                  {/* Details Button: Only rendered if there is at least one valid address */}
                  {showResults && !isPolygonView && validAddresses.length > 0 && (
                    <li className="z-30 flex-auto text-center">
                      <a
                        className={`z-30 flex items-center justify-center w-full px-4 py-2 text-sm mb-0 transition-all ease-in-out border border-white rounded-lg cursor-pointer ${viewAsGrid ? 'border-white text-blue-500 bg-[#D6DFFE]' : 'text-slate-600 bg-inherit'
                          }`}
                        role="tab"
                        aria-selected={viewAsGrid}
                        onClick={() => toggleView("grid")}
                      >
                        <img src={GridIcon} alt="View as Grid" className="w-4 h-4 mr-1.5" />
                        <span className="ml-1">Details</span>
                      </a>
                    </li>
                  )}
                </ul>

              </div>
            </div>
          )}

          {/* Map View (Initial State) */}
          {!showResults && (
            <div className="p-3 mx-auto mt-3 bg-white m-0 rounded-lg h-500px w-[100%]">
              {/* <h3 className="text-lg text-gray-700 font-semibold mb-4">Map View</h3> */}
              <div className="w-full overflow-hidden" style={{ height: 'calc(100vh - (290px))' }}>
                {isPolygonView ? (
                  <PolygonMapComponent />
                ) : (
                  <MapComponent />
                )}

              </div>
            </div>

          )}

          {/* Results Section */}
          {showResults && (
            <div className="mt-3">
              {viewAsGrid && !isPolygonView && (
                <div className="grid grid-cols-2 gap-4 rounded-lg bg-white shadow-shadow1 w-auto p-4">
                  {addressResults.length > 0 ? (
                    addressResults.map((address, index) => {
                      // Generate the pamCode (if needed for display)
                      const pamCode = address.pinCode + address.blockCode + address.addressCode;
                      return (
                        <div
                          key={address.id || index}
                          className="relative border p-3 rounded-md shadow-sm cursor-pointer hover:border-blue-500 w-94"
                          onClick={(e) => {
                            const target = e.target as HTMLElement;
                            // Only navigate if the click didn't occur inside a button
                            if (!target.closest('button')) {
                              // Check if the address has valid latitude and longitude
                              if (address.latitude && address.longitude) {
                                handleNavigateToGoogleMaps(address.latitude, address.longitude);
                              } else {
                                // Optionally, show a message if location data is missing
                                toast.error("Location not available for this address.");
                              }
                            }
                          }}
                        >
                          <div className="relative flex flex-col p-3">
                            {/* Top row: Address type info on the left and buttons on the right */}
                            <div className="flex justify-between items-center">
                              {/* Left side: Address type icons and labels */}
                              <div className="flex items-center gap-4">
                                {address.addressType?.toLowerCase() === 'office' && (
                                  <>
                                    <img
                                      src={OfficeIcon}
                                      alt="Office Icon"
                                      className="w-8 h-8 "
                                    />
                                    <span className="text-sm md:text-base font-bold text-gray-700">Office</span>
                                  </>
                                )}
                                {/* {address.addressType?.toLowerCase() === 'business' && (
                                  <>
                                    <img
                                      src={BussinessIcon}
                                      alt="Business Icon"
                                      className="w-6 h-6 rounded-full ring-1 ring-offset-4 ring-green-500"
                                    />
                                    <span className="text-sm md:text-base font-bold text-gray-700">Business</span>
                                  </>
                                )} */}
                                {address.addressType?.toLowerCase() === 'home' && (
                                  <>
                                    <img
                                      src={HomeIcon}
                                      alt="Home Icon"
                                      className="w-8 h-8 "
                                    />
                                    <span className="text-sm md:text-base font-bold text-gray-700">Home</span>
                                  </>
                                )}
                                {address.addressType?.toLowerCase() === 'other' && (
                                  <>
                                    <img
                                      src={OtherIcon}
                                      alt="Other Icon"
                                      className="w-8 h-8 "
                                    />
                                    <span className="text-sm md:text-base font-bold text-gray-700">Other</span>
                                  </>
                                )}
                                {!['office', 'home', 'other'].includes(address.addressType?.toLowerCase() || '') && (
                                  <>
                                    <img
                                      src={OtherIcon}
                                      alt="Custom Type Icon"
                                      className="w-8 h-8 "
                                    />
                                    <span className="text-sm md:text-base font-bold text-gray-700">
                                      {address.addressType}
                                    </span>
                                  </>
                                )}
                              </div>
                              {/* Right side: Buttons */}
                              <div className="flex gap-2">
                                <button
                                  title="Favourites"
                                  className="p-1 border border-[#D6DFFE] bg-[#D6DFFE] rounded-md hover:bg-[#c4d4fc] focus:outline-none flex-shrink-0"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    HeartClick(Number(address.id), address.isFavourite);
                                  }}
                                >
                                  <img
                                    src={address.isFavourite ? FavouriteTrue : FavouriteFalse}
                                    alt="Favourites"
                                    className="w-5 h-5"
                                  />
                                </button>
                                {/* <button
                                  title="Location"
                                  className="p-1 border border-[#D6DFFE] bg-[#D6DFFE] rounded-md hover:bg-[#c4d4fc] focus:outline-none"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleLocationIconClick(address.latitude, address.longitude);
                                  }}
                                >
                                  <img
                                    src={LocationIcon}
                                    alt="Location"
                                    className="h-6 w-6 cursor-pointer"
                                  />
                                </button> */}
                              </div>
                            </div>
                            {/* Bottom row: Address details */}
                            <div className="mt-2">
                              <p className="text-sm md:text-base font-medium text-[#61677D]">
                                {address.addressLine1}, {address.addressLine2}, {address.addressLine3}
                              </p>
                              <p className="text-sm text-[#61677D]">{address.pinCode}</p>
                              <p className="text-lg text-gray-600 font-bold">
                                {pamCode ? formatPamCode(pamCode) : "N/A"}
                              </p>
                            </div>
                          </div>

                        </div>
                      );
                    })
                  ) : (
                    <p className="text-gray-500">No addresses found.</p>
                  )}
                </div>
              )}



              {/* Map View (if applicable) */}
              {!viewAsGrid && (
                <div
                  className="mt-3 bg-white p-3 rounded-md overflow-hidden"
                  style={{ height: 'calc(100vh - (250px))' }}
                >
                  {isPolygonView ? (
                    <PolygonMapComponent addresses={addressResults} boundaryData={boundaryData} />
                  ) : isPolygonBlockView ? (
                    <PolygonBlockMap addresses={addressResults} boundaryData={boundaryData} />
                  ) : (
                    <MapComponent addresses={addressResults} boundaryData={boundaryData} showLocateControl={false} />
                  )}
                </div>
              )}
            </div>
          )}



        </div>
        {/* <div className="fixed -bottom-3 right-0 mr-[2%] w-[80%] bg-white shadow-shadow1 rounded-md border">
            <div className="px-8 py-4">
              <p className="text-center text-jetgrey text-sm">
                Postal Address Mapping. © 2024
              </p>
            </div>
          </div> */}


      </main>


      <div className="mt-3 bg-white rounded-md border">
        <div className="px-8 py-4">
          <p className="text-center text-jetgrey text-sm">
            GET ME THERE. © 2024
          </p>
        </div>
      </div>
    </div>
  );
};


{/* Your main content here */ }



export default Home;
